var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsSmallEmptyBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#777"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.723 17.824l-5.607-2.972L3.6 18l.968-6.497L0 6.984l6.204-1.043L8.9 0l2.867 5.852 6.232.848-4.434 4.66 1.158 6.464zm-2.02-2.768l-.748-4.179 2.935-3.086-4.119-.56-1.819-3.715L7.24 7.287l-4.103.69 3.026 2.994-.625 4.196 3.552-2.026 3.613 1.915z",
    fillRule: "evenodd"
  })));
}
export default SvgIconsSmallEmptyBookmark;